import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Polling {
  isPollingActive: boolean;
  isDownloadPollingActive: boolean;
  downloadFileId: string;
  downloadProgressValue: number;
  activeClientId: string;
}

const initialState: Polling = {
  isPollingActive: false,
  isDownloadPollingActive: false,
  downloadFileId: "",
  downloadProgressValue: 0,
  activeClientId: "",
};

export const pollingSlice = createSlice({
  name: "polling",
  initialState,
  reducers: {
    startPolling: (state) => {
      state.isPollingActive = true;
    },
    stopPolling: (state) => {
      state.isPollingActive = false;
    },
    startDownloadPolling: (
      state,
      {
        payload: { fileId, clientId },
      }: PayloadAction<{ fileId: string; clientId: string }>
    ) => {
      state.isDownloadPollingActive = true;
      state.downloadFileId = fileId;
      state.activeClientId = clientId;
    },
    stopDownloadPolling: (state) => {
      state.isDownloadPollingActive = false;
      state.downloadFileId = "";
      state.activeClientId = "";
    },
    setDownloadProgress: (
      state,
      { payload: progress }: PayloadAction<number>
    ) => {
      state.downloadProgressValue = progress;
    },
  },
});

export const {
  startPolling,
  stopPolling,
  startDownloadPolling,
  stopDownloadPolling,
  setDownloadProgress,
} = pollingSlice.actions;
